export const srcKeys = [
  {
    index: 0,
    style: {
      top: "7.6%",
      left: "0%",
    },
    layers: [{ key: "#00070029" }],
  },
  {
    index: 1,
    style: {
      top: "7.6%",
      left: "5.6%",
    },
    layers: [{ key: "#00070014" }],
  },
  {
    index: 2,
    style: {
      top: "0%",
      left: "11.2%",
    },
    layers: [{ key: "#0007001A" }],
  },
  {
    index: 3,
    style: {
      top: "0%",
      left: "16.8%",
    },
    layers: [{ key: "#00070008" }],
  },
  {
    index: 4,
    style: {
      top: "1.8%",
      left: "22.4%",
    },
    layers: [{ key: "#00070015" }],
  },
  {
    index: 5,
    style: {
      top: "1.8%",
      left: "28.0%",
    },
    layers: [{ key: "#00070017" }],
  },
  {
    index: 105,
    style: {
      top: "1.8%",
      left: "68.3%",
    },
    layers: [{ key: "#0007001C" }],
  },
  {
    index: 104,
    style: {
      top: "1.8%",
      left: "73.9%",
    },
    layers: [{ key: "#00070018" }],
  },
  {
    index: 103,
    style: {
      top: "0%",
      left: "79.5%",
    },
    layers: [{ key: "#0007000C" }],
  },
  {
    index: 102,
    style: {
      top: "0%",
      left: "85.1%",
    },
    layers: [{ key: "#00070012" }],
  },
  {
    index: 101,
    style: {
      top: "7.6%",
      left: "90.7%",
    },
    layers: [{ key: "#00070013" }],
  },
  {
    index: 100,
    style: {
      top: "7.6%",
      left: "96.3%",
    },
    layers: [{ key: "#00070031" }],
  },
  {
    index: 25,
    style: {
      top: "22%",
      left: "0%",
    },
    layers: [{ key: "#0007002B" }],
  },
  {
    index: 26,
    style: {
      top: "22%",
      left: "5.6%",
    },
    layers: [{ key: "#00070004" }],
  },
  {
    index: 27,
    style: {
      top: "14.4%",
      left: "11.2%",
    },
    layers: [{ key: "#00070016" }],
  },
  {
    index: 28,
    style: {
      top: "14.4%",
      left: "16.8%",
    },
    layers: [{ key: "#00070007" }],
  },
  {
    index: 29,
    style: {
      top: "16.1%",
      left: "22.4%",
    },
    layers: [{ key: "#00070009" }],
  },
  {
    index: 30,
    style: {
      top: "16.1%",
      left: "28.0%",
    },
    layers: [{ key: "#0007000A" }],
  },
  {
    index: 130,
    style: {
      top: "16.1%",
      left: "68.3%",
    },
    layers: [{ key: "#0007000B" }],
  },
  {
    index: 129,
    style: {
      top: "16.1%",
      left: "73.9%",
    },
    layers: [{ key: "#0007000D" }],
  },
  {
    index: 128,
    style: {
      top: "14.4%",
      left: "79.5%",
    },
    layers: [{ key: "#0007000E" }],
  },
  {
    index: 127,
    style: {
      top: "14.4%",
      left: "85.1%",
    },
    layers: [{ key: "#0007000F" }],
  },
  {
    index: 126,
    style: {
      top: "22%",
      left: "90.7%",
    },
    layers: [{ key: "#00070033" }],
  },
  {
    index: 125,
    style: {
      top: "22%",
      left: "96.3%",
    },
    layers: [{ key: "#00070034" }],
  },
  {
    index: 50,
    style: {
      top: "36%",
      left: "0%",
    },
    layers: [{ key: "#00920C0B" }],
  },
  {
    index: 51,
    style: {
      top: "36%",
      left: "5.6%",
    },
    layers: [{ key: "#0007001D" }],
  },
  {
    index: 52,
    style: {
      top: "28.6%",
      left: "11.2%",
    },
    layers: [{ key: "#0007001B" }],
  },
  {
    index: 53,
    style: {
      top: "28.6%",
      left: "16.8%",
    },
    layers: [{ key: "#00070006" }],
  },
  {
    index: 54,
    style: {
      top: "30.2%",
      left: "22.4%",
    },
    layers: [{ key: "#00070019" }],
  },
  {
    index: 55,
    style: {
      top: "30.2%",
      left: "28.0%",
    },
    layers: [{ key: "#00070005" }],
  },
  {
    index: 155,
    style: {
      top: "30.2%",
      left: "68.3%",
    },
    layers: [{ key: "#00070011" }],
  },
  {
    index: 154,
    style: {
      top: "30.2%",
      left: "73.9%",
    },
    layers: [{ key: "#00070010" }],
  },
  {
    index: 153,
    style: {
      top: "28.6%",
      left: "79.5%",
    },
    layers: [{ key: "#00070036" }],
  },
  {
    index: 152,
    style: {
      top: "28.6%",
      left: "85.1%",
    },
    layers: [{ key: "#00070037" }],
  },
  {
    index: 151,
    style: {
      top: "36%",
      left: "90.7%",
    },
    layers: [{ key: "#00070038" }],
  },
  {
    index: 150,
    style: {
      top: "36%",
      left: "96.3%",
    },
    layers: [{ key: "#00920C0E" }],
  },
  {
    index: 77,
    style: {
      top: "43%",
      left: "11.2%",
    },
    layers: [{ key: "#00070039" }],
  },
  {
    index: 78,
    style: {
      top: "43%",
      left: "16.8%",
    },
    layers: [{ key: "#00920C0D" }],
  },
  {
    index: 178,
    style: {
      top: "43%",
      left: "79.5%",
    },
    layers: [{ key: "#0007002F" }],
  },
  {
    index: 177,
    style: {
      top: "43%",
      left: "85.1%",
    },
    layers: [{ key: "#00070030" }],
  },
  {
    index: 7,
    style: {
      top: "55.6%",
      left: "22.7%",
      transform: "rotateZ(-60deg)",
      width: "6.4%",
    },
    layers: [{ key: "#000700E1" }],
  },
  {
    index: 56,
    style: {
      top: "58.9%",
      left: "28.5%",
      transform: "rotateZ(-60deg)",
      width: "6.4%",
    },
    layers: [{ key: "#0007002C" }],
  },
  {
    index: 31,
    style: {
      top: "68.4%",
      left: "34.5%",
      transform: "rotateZ(30deg)",
    },
    layers: [{ key: "#000700E0" }],
  },
  {
    index: 6,
    style: {
      top: "75.5%",
      left: "39.4%",
      transform: "rotateZ(30deg)",
    },
    layers: [{ key: "#0007004C" }],
  },
  {
    index: 106,
    style: {
      top: "75.5%",
      left: "57%",
      transform: "rotateZ(-30deg)",
    },
    layers: [{ key: "#000700E7" }],
  },
  {
    index: 131,
    style: {
      top: "68.4%",
      left: "61.8%",
      transform: "rotateZ(-30deg)",
    },
    layers: [{ key: "#000700E4" }],
  },
  {
    index: 156,
    style: {
      top: "58.9%",
      left: "65.1%",
      transform: "rotateZ(60deg)",
      width: "6.4%",
    },
    layers: [{ key: "#00070028" }],
  },
  {
    index: 107,
    style: {
      top: "55.6%",
      left: "70.8%",
      transform: "rotateZ(60deg)",
      width: "6.4%",
    },
    layers: [{ key: "#0007002A" }],
  },
  {
    index: 32,
    style: {
      top: "80.6%",
      left: "31.7%",
      transform: "rotateZ(30deg)",
    },
    layers: [{ key: "#000700E2" }],
  },
  {
    index: 57,
    disabled: true,
    style: {
      top: "87.9%",
      left: "36.6%",
      transform: "rotateZ(30deg)",
    },
    layers: [{ key: "#00920C0C" }],
  },
  {
    index: 157,
    disabled: true,
    style: {
      top: "87.9%",
      left: "59.8%",
      transform: "rotateZ(-30deg)",
    },
    layers: [{ key: "#00920C0F" }],
  },
  {
    index: 132,
    style: {
      top: "80.6%",
      left: "64.6%",
      transform: "rotateZ(-30deg)",
    },
    layers: [{ key: "#000700E6" }],
  },
];

export const dstKeys = {
  "#00070004": {
    text: [{ text: "A", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070005": {
    text: [{ text: "B", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070006": {
    text: [{ text: "C", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070007": {
    text: [{ text: "D", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070008": {
    text: [{ text: "E", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070009": {
    text: [{ text: "F", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000A": {
    text: [{ text: "G", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000B": {
    text: [{ text: "H", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000C": {
    text: [{ text: "I", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000D": {
    text: [{ text: "J", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000E": {
    text: [{ text: "K", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000F": {
    text: [{ text: "L", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070010": {
    text: [{ text: "M", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070011": {
    text: [{ text: "N", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070012": {
    text: [{ text: "O", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070013": {
    text: [{ text: "P", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070014": {
    text: [{ text: "Q", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070015": {
    text: [{ text: "R", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070016": {
    text: [{ text: "S", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070017": {
    text: [{ text: "T", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070018": {
    text: [{ text: "U", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070019": {
    text: [{ text: "V", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001A": {
    text: [{ text: "W", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001B": {
    text: [{ text: "X", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001C": {
    text: [{ text: "Y", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001D": {
    text: [{ text: "Z", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001E": {
    text: [
      { text: "!", style: { top: "30%", fontSize: "1.2em" } },
      { text: "1", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#0007001F": {
    text: [
      { text: "@", style: { top: "25%", fontSize: "1.2em" } },
      { text: "2", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070020": {
    text: [
      { text: "#", style: { top: "30%", fontSize: "1.2em" } },
      { text: "3", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070021": {
    text: [
      { text: "$", style: { top: "30%", fontSize: "1.2em" } },
      { text: "4", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070022": {
    text: [
      { text: "%", style: { top: "30%", fontSize: "1.2em" } },
      { text: "5", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070023": {
    text: [
      { text: "^", style: { top: "30%", fontSize: "1.2em" } },
      { text: "6", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070024": {
    text: [
      { text: "&", style: { top: "30%", fontSize: "1.2em" } },
      { text: "7", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070025": {
    text: [
      { text: "*", style: { top: "30%", fontSize: "1.2em" } },
      { text: "8", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070026": {
    text: [
      { text: "(", style: { top: "30%", fontSize: "1.2em" } },
      { text: "9", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070027": {
    text: [
      { text: ")", style: { top: "30%", fontSize: "1.2em" } },
      { text: "0", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070028": { text: [{ text: "Enter", style: { top: "50%" } }] },
  "#00070029": { text: [{ text: "Esc", style: { top: "50%" } }] },
  "#0007002A": {
    text: [{ text: "Backspace", style: { top: "50%" } }],
  },
  "#0007002B": {
    text: [{ text: "Tab", style: { top: "50%" } }],
  },
  "#0007002C": {
    text: [{ text: "Space", style: { top: "50%" } }],
  },
  "#0007002D": {
    text: [
      { text: "_", style: { top: "15%", fontSize: "1.4em" } },
      { text: "-", style: { top: "60%", fontSize: "1.4em" } },
    ],
  },
  "#0007002E": {
    text: [
      { text: "+", style: { top: "30%", fontSize: "1.4em" } },
      { text: "=", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#0007002F": {
    text: [
      { text: "{", style: { top: "25%", fontSize: "1.3em" } },
      { text: "[", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070030": {
    text: [
      { text: "}", style: { top: "25%", fontSize: "1.3em" } },
      { text: "]", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070031": {
    text: [
      { text: "|", style: { top: "25%", fontSize: "1.3em" } },
      { text: "\\", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070033": {
    text: [
      { text: ":", style: { top: "25%", fontSize: "1.4em" } },
      { text: ";", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#00070034": {
    text: [
      { text: '"', style: { top: "30%", fontSize: "1.4em" } },
      { text: "'", style: { top: "75%", fontSize: "1.4em" } },
    ],
  },
  "#00070035": {
    text: [
      { text: "~", style: { top: "30%", fontSize: "1.7em" } },
      { text: "`", style: { top: "90%", fontSize: "1.7em" } },
    ],
  },
  "#00070036": {
    text: [
      { text: "<", style: { top: "25%", fontSize: "1.8em" } },
      { text: ",", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070037": {
    text: [
      { text: ">", style: { top: "25%", fontSize: "1.8em" } },
      { text: ".", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070038": {
    text: [
      { text: "?", style: { top: "25%", fontSize: "1.5em" } },
      { text: "/", style: { top: "70%", fontSize: "1.4em" } },
    ],
  },
  "#00070039": {
    text: [
      { text: "Caps", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#0007003A": { text: [{ text: "F1", style: { top: "50%" } }] },
  "#0007003B": { text: [{ text: "F2", style: { top: "50%" } }] },
  "#0007003C": { text: [{ text: "F3", style: { top: "50%" } }] },
  "#0007003D": { text: [{ text: "F4", style: { top: "50%" } }] },
  "#0007003E": { text: [{ text: "F5", style: { top: "50%" } }] },
  "#0007003F": { text: [{ text: "F6", style: { top: "50%" } }] },
  "#00070040": { text: [{ text: "F7", style: { top: "50%" } }] },
  "#00070041": { text: [{ text: "F8", style: { top: "50%" } }] },
  "#00070042": { text: [{ text: "F9", style: { top: "50%" } }] },
  "#00070043": { text: [{ text: "F10", style: { top: "50%" } }] },
  "#00070044": { text: [{ text: "F11", style: { top: "50%" } }] },
  "#00070045": { text: [{ text: "F12", style: { top: "50%" } }] },
  "#00070046": {
    text: [
      { text: "Print", style: { top: "35%" } },
      { text: "Screen", style: { top: "65%" } },
    ],
  },
  "#00070047": {
    text: [
      { text: "Scroll", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070048": {
    text: [{ text: "Pause", style: { top: "50%" } }],
  },
  "#00070049": {
    text: [{ text: "Insert", style: { top: "50%" } }],
  },
  "#0007004A": {
    text: [{ text: "Home", style: { top: "50%" } }],
  },
  "#0007004B": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Up", style: { top: "65%" } },
    ],
  },
  "#0007004C": {
    text: [{ text: "Delete", style: { top: "50%" } }],
  },
  "#0007004D": {
    text: [{ text: "End", style: { top: "50%" } }],
  },
  "#0007004E": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Down", style: { top: "65%" } },
    ],
  },
  "#0007004F": {
    text: [{ text: "→", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070050": {
    text: [{ text: "←", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070051": {
    text: [{ text: "↓", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070052": {
    text: [{ text: "↑", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070053": {
    text: [
      { text: "Num", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070054": {
    text: [{ text: "/", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070055": {
    text: [{ text: "*", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070056": {
    text: [{ text: "-", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070057": {
    text: [{ text: "+", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070058": {
    text: [{ text: "Enter", style: { top: "50%" } }],
  },
  "#00070059": {
    text: [{ text: "1", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005A": {
    text: [{ text: "2", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005B": {
    text: [{ text: "3", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005C": {
    text: [{ text: "4", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005D": {
    text: [{ text: "5", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005E": {
    text: [{ text: "6", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005F": {
    text: [{ text: "7", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070060": {
    text: [{ text: "8", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070061": {
    text: [{ text: "9", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070062": {
    text: [{ text: "0", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070063": {
    text: [{ text: ".", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070076": {
    text: [{ text: "Menu", style: { top: "50%" } }],
  },
  "#000700E0": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E1": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E2": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E3": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },
  "#000700E4": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E5": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E6": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E7": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },

  "#000C00E2": {
    text: [{ text: "Mute", style: { top: "50%" } }],
  },
  "#000C00E9": {
    text: [{ text: "VolUp", style: { top: "50%" } }],
  },
  "#000C00EA": {
    text: [{ text: "VolDn", style: { top: "50%" } }],
  },
  "#000C00B6": {
    text: [{ text: "|◀", style: { top: "50%" } }],
  },
  "#000C00B5": {
    text: [{ text: "▶|", style: { top: "50%" } }],
  },
  "#000C00CD": {
    text: [{ text: "▶ / ‖", style: { top: "50%" } }],
  },

  "#00920C0B": {
    text: [
      { text: "Fn", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#00920C0C": {
    text: [{ text: "⬤", style: { top: "45%", left: "25%", fontSize: "2em" } }],
  },
  "#00920C0D": {
    text: [
      { text: "FnS", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#00920C1A": { text: [{ text: "LFn1", style: { top: "50%" } }] },
  "#00920C1B": { text: [{ text: "LFn3", style: { top: "50%" } }] },
  "#00920C1C": { text: [{ text: "LFn4", style: { top: "50%" } }] },
  "#00920C1D": { text: [{ text: "LFn5", style: { top: "50%" } }] },
  "#00920C1E": { text: [{ text: "LFn6", style: { top: "50%" } }] },
  "#00920C1F": { text: [{ text: "LFn7", style: { top: "50%" } }] },

  "#00920C0E": {
    text: [
      { text: "Fn", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#00920C0F": {
    text: [{ text: "⬤", style: { top: "45%", left: "25%", fontSize: "2em" } }],
  },
  "#00920C10": {
    text: [
      { text: "FnS", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#00920C20": { text: [{ text: "RFn1", style: { top: "50%" } }] },
  "#00920C21": { text: [{ text: "RFn3", style: { top: "50%" } }] },
  "#00920C22": { text: [{ text: "RFn4", style: { top: "50%" } }] },
  "#00920C23": { text: [{ text: "RFn5", style: { top: "50%" } }] },
  "#00920C24": { text: [{ text: "RFn6", style: { top: "50%" } }] },
  "#00920C25": { text: [{ text: "RFn7", style: { top: "50%" } }] },
  "#00920C13": { text: [{ text: "Layer1", style: { top: "50%" } }] },
  "#00920C14": { text: [{ text: "Layer2", style: { top: "50%" } }] },
  "#00920C15": { text: [{ text: "Layer3", style: { top: "50%" } }] },
  "#00920C16": { text: [{ text: "Layer4", style: { top: "50%" } }] },
  "#00920C17": { text: [{ text: "Layer5", style: { top: "50%" } }] },
  "#00920C18": { text: [{ text: "Layer6", style: { top: "50%" } }] },
  "#00920C19": { text: [{ text: "Layer7", style: { top: "50%" } }] },
};
